module.exports = __webpack_public_path__ + "static/volutes-right-f896d1d3cb6e23ade66292e0053ac82e.svg";